export type MenuLink = {
    title: string;
    handle?: string;
    url?: string;
    parent_handle?: string;
    level?: number;
    links?: MenuLink[];
};

export type AboutContactSettings = {
    companyName?: string;
    address?: string;
    phone?: string;
    phoneLabel?: string;
    email?: string;
    emailLabel?: string;
};

export type SocialSettings = {
    instagramUrl?: string;
    linkedinUrl?: string;
    youtubeUrl?: string;
    facebookUrl?: string;
};

export function getSocialLinks(social: SocialSettings) {
    return [
        { key: "instagram", label: "Instagram", url: social.instagramUrl?.trim() ?? "" },
        { key: "youtube", label: "YouTube", url: social.youtubeUrl?.trim() ?? "" },
        { key: "facebook", label: "Facebook", url: social.facebookUrl?.trim() ?? "" },
        { key: "linkedin", label: "LinkedIn", url: social.linkedinUrl?.trim() ?? "" },
    ].filter((link) => link.url);
}

export function getTopLevelLinks(settings: any): MenuLink[] {
    const tree = settings?.settings?.links?.[0]?.links;
    return Array.isArray(tree) ? tree : [];
}

export function hasChildren(link?: MenuLink): boolean {
    return Boolean(link?.links && link.links.length > 0);
}

/** L2 items with children = groups; without = standalone links */
export function splitPanelItems(panel?: MenuLink) {
    const items = panel?.links || [];
    const groups = items.filter(hasChildren);
    const standalone = items.filter((item) => !hasChildren(item));
    return { groups, standalone };
}

export function isAboutPanel(panel?: MenuLink): boolean {
    if (!panel) return false;
    const key = `${panel.handle || ""} ${panel.title || ""}`.toLowerCase();
    return key.includes("about");
}

export function toTelHref(phone: string): string {
    return phone.replace(/[^\d+]/g, "");
}

function maxGroupLinkCount(groups: MenuLink[]): number {
    return groups.reduce((max, group) => Math.max(max, group.links?.length || 0), 0);
}

export function getPanelColumnCount(
    groups: MenuLink[],
    standaloneCount = 0
): number {
    if (groups.length <= 1) return 1;

    if (groups.length === 2) {
        if (standaloneCount > 0) return 2;
        return maxGroupLinkCount(groups) > 4 ? 2 : 1;
    }

    if (groups.length <= 4) return 2;

    return 3;
}

export function distributeGroupsToColumns(groups: MenuLink[], columnCount: number): MenuLink[][] {
    if (columnCount <= 1 || groups.length === 0) {
        return [groups];
    }

    if (groups.length === columnCount) {
        return groups.map((group) => [group]);
    }

    const columns: MenuLink[][] = Array.from({ length: columnCount }, () => []);

    groups.forEach((group, index) => {
        columns[index % columnCount].push(group);
    });

    return columns.filter((column) => column.length > 0);
}
export function linkLooksLikeCta(title = ""): boolean {
    return title.trim().startsWith("→") || title.trim().startsWith("->");
}

